import React from "react";

const CircularProgress = ({ className }) => <div></div>;

export default CircularProgress;
